module.exports = __webpack_public_path__ + "static/media/10.cb823529.jpg";